import React, { useState } from "react";
import axios from "axios";
import { db } from '../firebase';
import { collection, addDoc } from "firebase/firestore";
import './AddGuppyScreen.css'; // Add your CSS file here
import AdminAppBar from "./AdminAppBar";

const AddGuppyScreen = () => {
  const [guppies, setGuppies] = useState([]);
  const [newGuppy, setNewGuppy] = useState({
    couplecount: "",
    name: "",
    guppynumber: "",
    coupleprice: "",
    maleprice: "", // Added maleprice
    femaleprice: "", // Added femaleprice
    sold_status: false,
    maleimage: null,
    femaleimage: null,
    malecount: "",
    femalecount: "",
    singular: false, // New field for checking if it's singular or not
  });
  const [error, setError] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [fileInputKey, setFileInputKey] = useState(Date.now());

  const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
  const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

  const handleFileChange = (event, type) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 50000000) {
        setError("File size should not exceed 50MB");
      } else if (type.includes("image") && !file.type.startsWith("image/")) {
        setError("Only image files are allowed.");
      } else {
        setError("");
        setNewGuppy((prev) => ({ ...prev, [type]: file }));
      }
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setNewGuppy({ ...newGuppy, [name]: value });
  };

  const uploadToCloudinary = async (file, type) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", UPLOAD_PRESET);

    const uploadUrl = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/${type}/upload`;

    try {
      const response = await axios.post(uploadUrl, formData, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percent);
        },
      });
      return response.data.secure_url;
    } catch (error) {
      console.error(`Upload Error (${type}):`, error);
      alert(`Failed to upload ${type}.`);
      return null;
    }
  };

  const handleUpload = async () => {
    if (error) return alert(error);

    setUploadProgress(0);
    const uploadedData = {};

    try {
      // Only upload images, no videos anymore
      if (newGuppy.maleimage) {
        const maleImageUrl = await uploadToCloudinary(newGuppy.maleimage, "image");
        if (maleImageUrl) uploadedData.maleimage = maleImageUrl;
      }

      if (newGuppy.femaleimage) {
        const femaleImageUrl = await uploadToCloudinary(newGuppy.femaleimage, "image");
        if (femaleImageUrl) uploadedData.femaleimage = femaleImageUrl;
      }

      const guppyData = {
        couplecount: parseInt(newGuppy.couplecount || 0, 10),
        malecount: parseInt(newGuppy.malecount || 0, 10),
        femalecount: parseInt(newGuppy.femalecount || 0, 10),
        name: newGuppy.name,
        coupleprice: parseFloat(newGuppy.coupleprice || 0),
        maleprice: parseFloat(newGuppy.maleprice || 0),
        guppynumber: parseFloat(newGuppy.guppynumber || 0),
        femaleprice: parseFloat(newGuppy.femaleprice || 0),
        sold_status: newGuppy.sold_status,
        singular: newGuppy.singular, // Check for singular status
        ...uploadedData,
      };

      const guppiesCollection = collection(db, "guppies");
      await addDoc(guppiesCollection, guppyData);

      try {
        const webhookUrl = process.env.REACT_APP_N8N_ADD_PRODUCT_WEBHOOK_URL || process.env.REACT_APP_N8N_ADD_GUPPY_WEBHOOK_URL;
        const response = await fetch(webhookUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ ...guppyData, itemType: "guppy" }),
        });

        if (!response.ok) {
          console.error("n8n Webhook Error. Status:", response.status);
          alert("✅ تم حفظ السمكة في المتجر\n❌ تأكد من تفعيل Workflow في n8n، لم يتم النشر على فيسبوك!");
        } else {
          console.log("Guppy info sent to n8n webhook successfully");
          alert("✅ تم إضافة السمكة بنجاح!\n✅ تم نشرها على صفحة فيسبوك تلقائياً!");
        }
      } catch (webhookError) {
        console.error("Failed to send guppy info to n8n webhook:", webhookError);
        alert("✅ تم حفظ السمكة في المتجر\n❌ حدث خطأ في الاتصال بسيرفر n8n للمنشورات!");
      }

      setGuppies((prev) => [...prev, guppyData]);
      setNewGuppy({
        couplecount: "",
        malecount: "",
        femalecount: "",
        name: "",
        coupleprice: "",
        maleprice: "",
        guppynumber: "",
        femaleprice: "",
        sold_status: false,
        maleimage: null,
        femaleimage: null,
        singular: false, // Reset singular check
      });
      setUploadProgress(0);
      setFileInputKey(Date.now()); // Reset file inputs
    } catch (error) {
      console.error("Upload Error:", error);
      alert("❌ فشل في رفع بيانات السمكة. يرجى المحاولة مرة أخرى.");
    }
  };

  return (
    <div>
      <AdminAppBar />
      <div className="page-container">
        <h1 className="title">Upload Guppy Info</h1>
        {error && <p className="error-message">{error}</p>}
        <div className="input-card">
          {/* Input fields for images only (no videos) */}
          {['maleimage', 'femaleimage'].map((type) => (
            <React.Fragment key={type}>
              <label className="label">{type.replace(/(male|female)/, '$1 Guppy ').replace(/([a-z])([A-Z])/, '$1 $2')}</label>
              <input key={`${fileInputKey}-${type}`} type="file" accept="image/*" onChange={(e) => handleFileChange(e, type)} className="input-field" />
            </React.Fragment>
          ))}

          {/* Input fields for guppy info */}
          {['couplecount', 'malecount', 'femalecount', 'name', 'coupleprice', 'maleprice', 'femaleprice', 'guppynumber'].map((field) => (
            <React.Fragment key={field}>
              <label className="label">{field.replace(/([a-z])([A-Z])/, '$1 $2')}</label>
              <input
                type={field.includes("price") ? "number" : "text"} // Set type to "number" for price fields
                name={field}
                value={newGuppy[field]}
                onChange={handleInputChange}
                className="input-field"
              />
            </React.Fragment>
          ))}

          {/* Checkbox for Singular/Couple */}
          <div className="checkbox-container">
            <label className="label">هل هو فرد أم زوج؟</label>
            <input
              type="checkbox"
              checked={newGuppy.singular}
              onChange={(e) => setNewGuppy({ ...newGuppy, singular: e.target.checked })}
              className="checkbox-field"
            />
            <span>فرد</span>
          </div>

          <button onClick={handleUpload} className="upload-button">Upload Guppy</button>
          {uploadProgress > 0 && <div className="progress-container"><div className="progress-bar" style={{ width: `${uploadProgress}%` }}></div></div>}
        </div>
      </div>
    </div>
  );
};

export default AddGuppyScreen;
